export default __webpack_public_path__ + "static/media/cat.8b80cbf1.svg";